import React from 'react';
import { Filter, ReferenceInput, SelectInput } from 'react-admin';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';
import UserAutocompleteInput from '../../../../commonComponents/UserAutocompleteInput';

const QuickTipsReportsFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput label="Quick Tip" source="id" reference="admin/quick-tips" alwaysOn>
      <SelectInput optionText="question" />
    </ReferenceInput>
    <UserAutocompleteInput label="User ID" source="user_id" alwaysOn />
    <CustomDateInput label="Choose start date" source="start_date" start alwaysOn />
    <CustomDateInput label="Choose end date" source="end_date" end alwaysOn />
  </Filter>
);

export default QuickTipsReportsFilter;
